import { useQuery } from '@tanstack/react-query';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { DocumentLibraryService } from '@dealstack/frontend/shared/dataExchange/services/document-library/document-library.service';
import { FindPersonsInDealRes } from '@dealstack/shared/lib/generated';

export const usePersonsInDeal = (dealId: string | undefined) => {
	const { data, isLoading } = useQuery({
		queryKey: [
			formatUnicorn(API_PATHS.DEAL_DEALID_DOCUMENT_LIBRARY_PERSONS_IN_DEAL_GET, {
				dealId: dealId || '',
			}),
		],
		queryFn: ({ signal }) =>
			DocumentLibraryService.get<FindPersonsInDealRes>(
				formatUnicorn(API_PATHS.DEAL_DEALID_DOCUMENT_LIBRARY_PERSONS_IN_DEAL_GET, {
					dealId: dealId || '',
				}),
				undefined,
				signal
			),
		enabled: !!dealId,
	});

	return {
		data: data?.payload?.persons,
		isLoading,
	};
};
